module.exports = __webpack_public_path__ + "media/images/rollerblade-f9bc24609f95518b6ca1b058e4bb6454.png";